import { type FC } from "react";

import { TextContent } from "../../../lens/components/shared";
import { formatDate } from "../../utils";

interface LensUpdateAtDate {
    seconds: number | undefined;
}

export const LensUpdateAtDate: FC<LensUpdateAtDate> = ({ seconds }) => {
    const formattedDate = formatDate(seconds);
    return <TextContent>{formattedDate}</TextContent>;
};
